import { createClient } from "@supabase/supabase-js";

const supabaseUrl =
  import.meta.env.VITE_SUPABASE_URL ||
  "https://ioesdloguneztfrwyfwp.supabase.co";

const supabaseAnonKey =
  import.meta.env.VITE_SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlvZXNkbG9ndW5lenRmcnd5ZndwIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEyNzQ4OTEsImV4cCI6MjA5Njg1MDg5MX0.Q_aJtuFNc6X6JgGV81iQMOoycYYHgDZnbWb9bkUHp40";

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
